import { io, Socket } from 'socket.io-client';
const SOCKET_URL = process.env.REACT_APP_SOCKET_URI ? process.env.REACT_APP_SOCKET_URI : '';
const socket: Socket = io(SOCKET_URL, {
  withCredentials: false,
  autoConnect: true,
}); 

export default socket;
